import React from 'react';
import { Trans } from 'react-i18next';

import { IconAppPolls } from 'app/components/_Icons';

import styles from './AppPollsNA.scss';


type Props = {
  type: string,
  name: string,
  description: string,
};

const AppPolls = ({ name, type, description }: Props) => (
  <div className={styles.root}>
    <div className={styles.header}>
      <IconAppPolls className={styles.icon} />
      <div>
        <div className={styles.type}>{type}</div>
        <h2 className={styles.name}>{name}</h2>
      </div>
    </div>
    <div className={styles.desc}>
      {description}
    </div>
    <div className={styles.footer}>
      <Trans i18nKey="subs:connect_by_school">
        {'Подключается образовательным учреждением'}
      </Trans>
    </div>
  </div>
);

export default AppPolls;
